import React from 'react';
import { useTranslation } from 'react-i18next';
import { converterCategories } from '../data/mock';

const FullConverters = ({ onSelectConverter }) => {
  const { t } = useTranslation();

  const renderCategory = (key, category, isLeft = true) => (
    <div key={key} className="mb-6">
      <h4 className="text-sm font-semibold text-gray-700 mb-2">
        {t(`sidebar.categories.${key}`, category.title)}
      </h4>
      <ul className="space-y-0.5">
        {category.items.map((item) => (
          <li key={item.id} className="flex items-center gap-1">
            <span className="text-gray-400 text-xs">•</span>
            <button
              onClick={() => onSelectConverter(key, item.id)}
              className="text-[#2563eb] hover:text-[#1d4ed8] hover:underline text-sm transition-colors text-left"
            >
              {t(`sidebar.converters.${item.id}`, item.name)}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );

  const categoryKeys = Object.keys(converterCategories);
  const leftCategories = ['common', 'engineering', 'heat', 'fluids', 'light'];
  const rightCategories = ['electricity', 'magnetism', 'radiology', 'other'];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">{t('common.fullConverters')}</h3>

      <div className="grid md:grid-cols-2 gap-x-8">
        <div>
          {leftCategories.map(key =>
            converterCategories[key] && renderCategory(key, converterCategories[key], true)
          )}
        </div>
        <div>
          {rightCategories.map(key =>
            converterCategories[key] && renderCategory(key, converterCategories[key], false)
          )}
        </div>
      </div>
    </div>
  );
};

export default FullConverters;
